module.exports = __webpack_public_path__ + "static/media/without.45158bcb.svg";